import { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

import { MdDeleteForever, MdOutlineDeleteOutline } from "react-icons/md";

import { AppContext } from "../../Context";
import Popups from "../../components/Pop";
import  Fetch, { Loader, GET, FetchAsync } from "../../inc/Fetch"; 
import { Input, SelectBox, ClassesDropdown, RichText, UploadForm } from '../../components/Form'

import './css/sendTask.css'
import { Img } from '../../components/Elements';

export default function SendGame() {
    
    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const { successData } = useContext(AppContext);
    const [open, setopen] = successData;

    let games = location.state?.games;

    const maxTabs = 2;
    const [loader, setloader] = useState(true);
    const [loading, setloading] = useState(false);
    const [tab, settab] = useState(1);
    const [values, setvalues] = useState({ _id: params?._id || false });

    async function loadData() {

        let res = await FetchAsync("/games/sendGame", { games: games, _id: params?._id });

        if (res?.error == "login") {
            navigate("/");
        } else {

            setvalues(res);

            // if (!res?.edit) {


            // } else {
            //     setvalues(res?.edit);
            // }

            setloader(false);
        }

    }

    function deleteGames(_id) {

        const conf = window.confirm(t("error",  { returnObjects: true })[2],);
        if (!conf) return false;

        setvalues(prev => ({
            ...prev,
            games: prev.games.filter(game => game._id !== _id)
        }));

    }

    function submit(){ 

        setloading(true);
        Fetch("games/send", (d) => {
            
            
            if (d?.error) {

                setopen({
                    // title:"Error",
                    short:t("error",  { returnObjects: true })[d?.error],
                    error:true
                });

            } else {
                setopen({
                    // title:"Error",
                    // short:t("error",  { returnObjects: true })[d?.error],
                    error:false
                });

                navigate(-1);
            }
            
            setloading(false);
        }, values);
    }

    function nextBack(t) {
        if (t) {
            checkValues(tab <= 1 ? 1 : tab - 1)
        } else {
            checkValues(tab >= maxTabs ? maxTabs : tab + 1)
        }
    }

    function checkValues(d) {
        settab(d);
    }


    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        
        if (!loader && !values?.games?.length) {
            navigate(-1);
        }

    }, [loader, values?.games])
    
    
    if (loader) {
        return <Loader />
    }

    // if (!values?.games?.length) {
    //     return false;
    // }

    
    return (
        <>
            {loading && <Loader />}
            <Popups style={{maxWidth:600,}}>
                <h1>{t("task_start_send")}</h1>

                <nav className='tabs'>
                    <a onClick={() => checkValues(1)} className={tab == 1 ? "ck" : "none"}>{t("game_info")}</a>
                    <a onClick={() => checkValues(2)} className={tab == 2 ? "ck" : "none"}>{t("tasks_send_op_2")}</a>
                </nav>

                {tab == 1 && <div className='popupBody' style={{padding:15}}>
                    <div className='newGameInfoBox' style={{marginTop:5}}>
                        
                        <div className='selectedGamesBox'>

                            {values?.games?.map((v, k) => {
                                return (
                                    <section>
                                        <Img src={v?.img[0]} />
                                        <div>
                                            <h3>{v?.name}</h3>
                                            <h4>{v?.subject?.name}</h4>
                                        </div>

                                        <a onClick={() => deleteGames(v?._id)} className='delete'><MdDeleteForever /></a>
                                    </section>
                                );
                            })}
                        </div>
         
                    </div>
                </div>}


                {tab == 2 &&  <div className='popupBody sendTaskBox ' style={{padding:15}}>
                    

                    <ClassesDropdown 
                        click={params?.task ? true : false}
                        validate={true}
                        type="own"
                        onChange={(d) => setvalues(p => ({
                            ...p,
                            classes:d,
                        }))}
                        value={values?.classes}
                        
                    />


                    <div style={{display:"flex", alignItems:"center", gap:0, maxWidth:400}}>

                        <Input 
                            placeholder={" "}
                            title={t("tasks_send_show_date")}
                            type='datetime-local'
                            onChange={(d) => setvalues(p => ({
                                ...p,
                                start_date:d, 
                            }))}
                            value={values?.start_date}
                            style={{flex:1}}
                        />


                        <Input 
                            placeholder={" "}
                            title={t("tasks_send_show_enddate")}
                            type='datetime-local'
                            onChange={(d) => setvalues(p => ({
                                ...p,
                                end_date:d, 
                            }))}
                            value={values?.end_date}
                            style={{flex:1}}
                        />
                    </div>
                    
                </div>}

                <div className='taskBtnSend'>
                    <button className='btn prev' onClick={() => nextBack(true)}>{t("prev")}</button>
                    {tab == maxTabs ? 
                        <button className='btn send' onClick={submit}>{t("tasks_send_now")}</button>
                        :
                        <button className='btn send' onClick={() => nextBack()}>{t("next")}</button>
                    }
                </div>
            </Popups>
        </>
    )
}
